module.exports = __webpack_public_path__ + "img/DE00335.f9d6fd7a.png";